var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
export function ElementChipList(_a) {
    var children = _a.children;
    return (_jsx(Box, __assign({ sx: {
            display: "inline-flex",
            flexWrap: "wrap",
            gap: "4px",
            alignItems: "center",
            maxWidth: "100%",
            minWidth: 0,
        } }, { children: children })));
}
